import { PageHeader } from 'antd'
import React from 'react'
import JobCalendar from '../components/job/job-calendar'

class MyEventPage extends React.Component {
  render() {
    return (
      <>
        <PageHeader title="่ตารางงานของฉัน"/>
        <div>ระบบจะแสดงเฉพาะรายการที่ผู้รับผิดชอบเป็นคุณ</div>
       <JobCalendar onlyOwner/>
      </>
    )
  }
}


export default MyEventPage
